export const resetPassword = {
    title: 'Сброс пароля',
    newPassword: 'Новый пароль',
    confirmNewPassword: 'Подтвердите новый пароль',
    resetSuccess: 'Вы успешно сбросили пароль',
    buttonSave: 'Сохранить',
};
